//This should be an API class that generalizes all API requests
import APPSETTINGS from '../appsettings.json';

const COSMOS_API = process.env.NODE_ENV === 'production' ? APPSETTINGS.production.cosmosapi : APPSETTINGS.development.cosmosapi;
// There are two API calls so implementing it this way for now
const EXTERNAL_API = process.env.NODE_ENV === 'production' ? APPSETTINGS.production.externalapi : APPSETTINGS.development.externalapi;

// const GENERATE_JWT_API = process.env.NODE_ENV === 'production' ? APPSETTINGS.production.generatejwtapi : APPSETTINGS.development.generatejwtapi;

enum Endpoints {
    GetApplicationData = 'GetApplicationData',
    SaveUserData = "SaveUserDataProgProf",
    GetInstitutions = "GetInstitutions",
    GetPositions = "GetPositions",
    GetFacilities = "GetFacilities",
    GetUserData = "GetUserDataProgProf",
    WriteSupportRequest = "WriteSupportRequestProgProf",
    GetApplicationsList = "GetApplicationsList",
    GetRegistrationValuesForApplication = "GetRegistrationValuesForApplication"
}


export class API {
    //not sure why API_CONFIG is mapped to RequestInfo, but if this isn't needed then the mapping could be removed
    // and use an enum instead with the endpoints, and all that is needed is the COSMOS_API prefix in the bellow functions.

    //every thing is POST?
    //usage: //API.POST(body, Enpoints.getNotifications);
    static POST = async (body: any, endpointName: Endpoints, token: string, logging = false) => {
        const API_ENDPOINT =
            ((endpointName === Endpoints.GetInstitutions || endpointName === Endpoints.GetPositions || endpointName === Endpoints.GetFacilities) ?
                EXTERNAL_API : COSMOS_API) + endpointName;

        if (logging) console.log("API POST: " + API_ENDPOINT);

        var headers = new Headers();
        var bearer = "Bearer " + token;
        headers.append("Authorization", bearer);

        const response = await fetch(API_ENDPOINT!, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        })

        const data = await response.json();
        if (logging) console.log(data);
        return data;
    }

    static GET = async (endpointName: Endpoints, token: string, logging = false) => {
        const API_ENDPOINT =
            ((endpointName === Endpoints.GetInstitutions || endpointName === Endpoints.GetPositions || endpointName === Endpoints.GetFacilities) ?
                EXTERNAL_API : COSMOS_API) + endpointName;

        if (logging) console.log("API POST: " + API_ENDPOINT);

        var headers = new Headers();
        var bearer = "Bearer " + token;
        headers.append("Authorization", bearer);

        const response = await fetch(API_ENDPOINT!, {
            headers: headers
        });

        const data = await response.json();
        if (logging) console.log(data);
        return data;
    }
}

export { Endpoints };